import { transformOptionsWithIcon } from "../components/desktop/list/table/cells/SelectCell/selectOptionUtils";

export const SAG_ICON_CONFIG = {
	src: "/sag.jpg",
	alt: "SAG",
	title: "Producto registrado en SAG",
	width: "20px",
};

export const transformCropsWithSagIcon = (crops) => {
	if (!crops || !Array.isArray(crops)) return [];

	return transformOptionsWithIcon(crops, (option) => option.from_sag === true, SAG_ICON_CONFIG);
};
